import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import translations from "../../shared/Translations";
import "./index.css";
import superAdminApis from "../../api/services/admin-pages/superAdmin";
import { toast } from "react-toastify";
import AOS from "aos";
import "aos/dist/aos.css";

function CustomerPay() {
  const navigate = useNavigate();

      useEffect(() => {
          AOS.init({
            duration: 1000,  
            once: false,    
            mirror: true,    
          });
        }, []);

    const [editId,setEditId] = useState('')
    const [urlValue,setUrlValue] =useState("")
    const [id,setId] = useState("")
const [customerData, setCustomerData] = useState(null);
const [submit, setSubmit] = useState(false);

  const [lang, setLang] = useState("en");
  const t = (key) => translations[lang][key] || key;

  const [paymentAmount, setPaymentAmount] = useState("");
  const [closedDate,setClosedDate] = useState("")
const [interestAmountInput, setInterestAmount] = useState("");
  const [upiNumber, setUpiNumber] = useState("");

  const [paymentMethod, setPaymentMethod] = useState("");
const todayDate = new Date().toLocaleDateString("en-GB");
  const totalLoan = customerData?.loan_amount || 0;
const interestRate = customerData?.intrest_rate || 0;
const interestAmount = customerData?.intrest_details?.interest_amount || 0;
const totalAmount = customerData?.total_amount || 0;
const paidAmount = customerData?.paid_amount || 0;
const loanId = customerData?.loan_id ||0;
const jewelName  = customerData?.jewel_name || "";
const jewelWeight  = customerData?.jewel_weight ||0;

const interestStatus =
  String(customerData?.intrest_details?.intrest_status).toLowerCase() === "true";

  console.log(customerData?.intrest_details?.intrest_status);

  console.log("RAW:", customerData?.intrest_details?.intrest_status);
console.log("FINAL:", interestStatus);
console.log("TYPE:", typeof interestStatus);
  
  
const remaining = customerData?.balance ==""?customerData?.loan_amount:customerData?.balance;
const totalDue =
  (parseFloat(remaining) || 0) +
  (parseFloat(interestAmount) || 0);
console.log(totalDue);


const loanStartDate = customerData?.date
  ? new Date(customerData.date).toLocaleDateString("en-GB")
  : "-";



const monthsDiff =customerData?.intrest_details?.months_applied
 

const [calculationAmt, setCalculationAmt] = useState("");
const [interestPaid, setInterestPaid] = useState(0);
const [principalPay, setPrincipalPay] = useState(0);

  useEffect(() => {
    const savedLang = localStorage.getItem("lang");
    if (savedLang) setLang(savedLang);
  }, []);

   useEffect(()=>{
   const queryParams = window.location.pathname;
      const myArray = queryParams.split("/");
      setEditId(myArray[2])
          setUrlValue(myArray[2])
          setId(myArray[2])
  
      console.log(myArray[5]);
      
  },[])
  
    useEffect(() => {
     
    if (editId) {
      handleCustomerDetailsGet(editId);
    }
  }, [editId]);

  const handleBackCustomer = () => {
    navigate("/customer-list");
  };

    const handleCustomerDetailsGet = (customerId) => {
      superAdminApis.customerDetailsGet(customerId)
        .then((responseData) => {
          if (responseData?.apiStatus?.code === "200") {
            const result = responseData?.result;
             setCustomerData(result);
          
          } else {
            console.error("Failed to fetch customer details");
          }
        })
        .catch((error) => {
          console.error("Error fetching customer details:", error);
        });
    };


const handlePay = async () => {
  setSubmit(true);

    const principalValue = parseFloat(principalPay || 0);
  const interestValuePayAmout = parseFloat(customerData?.payAmount || 0);

  const prevRemaining = Number(
    customerData.remaining_balance ||
      customerData?.balance ||
      customerData?.loan_amount ||
      0
  );
  const newRemainingLoan = Math.max(prevRemaining - principalValue, 0);
  const isClosed = newRemainingLoan === 0;

  const amount = Number(interestAmountInput);

const remainingValue = Number(customerData?.balance || customerData?.loan_amount || 0);
const interestValue = Number(interestAmountInput || 0);

const isFullPrincipal =
  Math.abs(principalValue - remainingValue) < 0.01;

const hasInterest = interestValue > 0;
const isMissingDate = !closedDate;
const isMissingInterest = interestValue <= 0;

// CASE 1: full principal but no interest
if (interestStatus) {
  // skip this validation completely
} else {
  if (isFullPrincipal && isMissingInterest) {
    toast.error("⚠️ Interest amount is required for full settlement");
    return;
  }
}
// CASE 2: full principal + interest but no date
if (isFullPrincipal && hasInterest && isMissingDate) {
  toast.error("⚠️ Please select Loan Closed Date to fully settle the loan");
  return;
}

// CASE 3: safety fallback
if (isFullPrincipal && isMissingDate) {
  toast.error("⚠️ Loan Closed Date required");
  return;
}




  if (!paymentMethod) {
    toast.error("Select payment method");
    setSubmit(false);
    return;
  }

  if (paymentMethod === "upi" && !upiNumber) {
    toast.error("Enter UPI number");
    setSubmit(false);
    return;
  }

  // ================= USE UI VALUES (IMPORTANT FIX) =================
  const updatedInterestPaid =
    Number(customerData?.interest_paid || 0) + Number(interestPaid || 0);

  const updatedPrincipalPaid =
    Number(customerData?.principal_paid || 0) + Number(principalPay || 0);

  const updatedPaidAmount =
    Number(customerData?.paid_amount || 0) + Number(calculationAmt || 0);

  // ================= CALCULATE BALANCE PROPERLY =================
  const loanAmount = Number(customerData?.loan_amount || 0);
  const totalPaid = updatedPrincipalPaid + updatedInterestPaid;
  const balance = loanAmount - updatedPrincipalPaid;

  // const isClosed = balance <= 0;

    // ===== Remaining Loan Calculation =====

     const now = new Date();
      const payloadDate = `${now.getFullYear()}-${String(
    now.getMonth() + 1
  ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(
    now.getHours()
  ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(
    now.getSeconds()
  ).padStart(2, "0")}`;


 const apiData = {
  customerDetails: {
    id: customerData.id,
    name: customerData.name,
    date: customerData.date,
    phone_no: customerData.phone_no,
    alter_phone_no: customerData.alter_phone_no,

    loan_amount: customerData.loan_amount || customerData.previous_loan_amount,
    intrest_rate: customerData.intrest_rate,
    duration_type: customerData.duration_type,
    duration: customerData.duration,

    intrest_amount: interestAmount,

    total_amount: customerData.total_amount,


  ...(interestAmountInput !== "" && amount > 0
      ? { interest_paid: amount }
      : {}),

principal_paid: Number(principalPay || 0),

    paid_amount: Number(principalPay || 0) + Number(amount || 0),


    // last_payment_date: new Date()
    //   .toISOString()
    //   .slice(0, 19)
    //   .replace("T", " "),

    last_payment_date:payloadDate,

    paid_status: isClosed ? "Closed" : "Active",

    closed_date: closedDate,

    aadhar_no: customerData.aadhar_no,
    release_date: customerData.release_date,
    address: customerData.address,

    live_img: customerData.live_img,
    aadhar_img: customerData.aadhar_img,
    aadhar_img_1: customerData.aadhar_img_1,

    jewel_img: customerData.jewel_img,
    guardian_name: customerData.guardian_name,
    jewel_name: customerData.jewel_name,
    jewel_weight: customerData.jewel_weight,
    jewel_amount: customerData.jewel_amount,
    jewel_dust_weight: customerData.jewel_dust_weight,

    optional_img: customerData.optional_img,
    created_by: customerData.created_by,

    pay_method: paymentMethod,
    upi_number: upiNumber,

    additional_loan_amt: customerData.additional_loan_amt,
    additional_loan_date: customerData.additional_loan_date,

    balance: newRemainingLoan.toFixed(2),
  },
};

  try {
    const response = await superAdminApis.customerDetailsUpdateAPI(apiData);
    setSubmit(false);

    if (response?.apiStatus?.code === "200") {
      toast.success(isClosed ? "Loan Closed!" : "Payment successful!");
      navigate("/customer-list");
    } else {
      toast.error("Failed to update payment");
    }
  } catch (err) {
    setSubmit(false);
    toast.error("Error while saving payment details.");
  }
};
  


  return (
    <div>
      {/* Breadcrumb */}
      <div className="d-flex justify-content-between align-items-center mt-3 mb-4">
        <nav aria-label="breadcrumb" className={lang === "ta" ? "fs-tamil" : ""}>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <a href="#" onClick={handleBackCustomer}>
                {t("dashboard")}
              </a>
            </li>
            <li className="breadcrumb-item active">{t("customerPay")}</li>
          </ol>
        </nav>

        <button className="btn add-customer" onClick={handleBackCustomer}>
          <i className="fa fa-arrow-left me-2"></i>
          {t("back")}
        </button>
      </div>

      {/* Container */}
      <div className="customer-list-container card p-3">
<div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-2 mb-4">
 <h5 className={`heading-with-line mb-2 mb-md-0 aquanew-text-effect ${lang === "ta" ? "fs-tamil" : ""}`}>
    Pay Loan Amount - Customer Name - Selva
    <span className="smooth-line"></span>
  </h5>
</div>


        {/* <h6
          className={`heading-with-line aquanew-text-effect ${
            lang === "ta" ? "fs-tamil" : ""
          }`}
        >
          {t("customerPay")}
        </h6> */}

<div className="container mt-3">

  {/* 🔹 Loan Summary */}
<div className="row mb-3"  data-aos="fade-right">

  {/* Total Loan */}
 <div className="col-md-4 mb-2">
  <div className="card p-3 summary-card shadow-sm position-relative total-loan-card">

    <small className="mb-2">Total Loan</small>
    <h6>₹{totalLoan}</h6>

    {/* Icon */}
    <i className="fa-solid fa-sack-dollar card-icon"></i>

  </div>
</div>

  {/* Remaining Principal */}
  <div className="col-md-4 mb-2">
    <div className="card p-3 summary-card shadow-sm remaining-card">
      <small className="mb-2">Remaining</small>
      <h6>₹{remaining}</h6>
      <i className="fa-solid fa-wallet card-icon"></i>
    </div>
  </div>

 
   <div className="col-md-4 mb-2">
    <div className="card p-3 summary-card shadow-sm  text-black total-due-card">
      <small className="mb-2">Full Months Since Last Payment</small>
      <h6>{monthsDiff} Months</h6>
      <i className="fa-solid fa-money-bill-wave card-icon"></i>
    </div>
  </div>

   {/* Interest Rate */}
  <div className="col-md-3 mb-2">
    <div className="card p-3 summary-card shadow-sm interest-card">
      <small className="mb-2">Interest</small>
      <h6>{interestRate}%</h6>
      <i className="fa-solid fa-percent card-icon"></i>
    </div>
  </div>

  <div className="col-md-3 mb-2">
    <div className="card p-3 summary-card shadow-sm text-dark interest-due-card">
      <small className="mb-2">Interest Due</small>
      <h6>₹{interestAmount}</h6>
      <i className="fa-solid fa-triangle-exclamation card-icon"></i>
    </div>
  </div>

  <div className="col-md-3 mb-2">
    <div className="card p-3 summary-card shadow-sm bg-danger text-white total-due-card">
      <small className="mb-2">Total Due</small>
      <h6>₹{totalDue}</h6>
      <i className="fa-solid fa-money-bill-wave card-icon"></i>
    </div>
  </div>

    <div className="col-md-3 mb-2">
    <div className="card p-3 summary-card shadow-sm text-dark interest-due-card">
      <small className="mb-2">Loan Start Date</small>
      <h6>{loanStartDate}</h6>
 <i className="fa-solid fa-calendar-days date-icon card-icon"></i>
     </div>
  </div>

  

</div>

  {/* 🔹 Jewel Details */}
  <div className="card p-3 shadow-sm summary-card border-0 rounded-3 mb-3 mt-5"  data-aos="fade-left">
    <h6 className="fw-bold mb-3">💎 Jewel Details</h6>

    <div className="row">
      <div className="col-md-3"><b>GL No:</b> {loanId}</div>
      <div className="col-md-3"><b>Name:</b> {jewelName}</div>
      <div className="col-md-3"><b>Weight:</b> {jewelWeight+' '+"gram"}</div>
      <div className="col-md-3"><b>Today Date:</b> {todayDate}</div>
    </div>
  </div>

  <div className='mt-5 mb-5' style={{ display: 'flex', alignItems: 'center', gap: '20px', padding:'0 13px' }}>
  <label style={{ marginBottom: 0 }}>🟡 Enter Payment Amount (₹)</label>
  

<input
  type="number"
  onWheel={(e) => e.preventDefault()}
  className='form-controlss'
  value={calculationAmt}
  onChange={(e) => {
    const raw = e.target.value;
    const val = parseFloat(raw);

    setCalculationAmt(raw);

    if (isNaN(val)) {
      setInterestPaid(0);
      setPrincipalPay(0);
      return;
    }

    // ✅ Interest gets paid first
    const interestPart = Math.min(val, interestAmount);
    const principalPart = val - interestPart;

    setInterestPaid(interestPart);
    setPrincipalPay(principalPart);
  }}
/>


<div style={{ alignSelf: "flex-end" }}>
  💡 Interest Paid: ₹{interestPaid || 0} | Principal Paid: ₹{principalPay || 0}
</div>

</div>

  {/* 🔹 Payment Section */}
 <div className="card p-4 shadow border-0 rounded-3 border-input-hover">
  <h6 className="fw-bold mb-4">💳 Make Payment</h6>


<div className="row align-items-stretch" >

  {/* Interest */}
<div className="col-md-6 mb-2 d-flex">

  {interestStatus ? (
    <div
      className="alert alert-success w-100 d-flex align-items-center justify-content-center"
      style={{ padding: "15px" }}
    >
      🎉  இந்த மாத வட்டி ஏற்கனவே செலுத்தப்பட்டுள்ளது.
    </div>
  ) : (
    <div className="w-100 d-flex flex-column">
      <label>Interest Pay</label>

      <input
        type="number"
        className="form-control"
        placeholder={`Enter Interest Amount ₹${interestAmount }`}
        value={interestAmountInput}
        onChange={(e) => setInterestAmount(e.target.value)}
      />
    </div>
  )}

</div>

  {/* Principal */}
<div className="col-md-6 mb-2">

  {customerData?.paid_status === "Closed" ? (
    <div
      className="alert alert-success w-100 d-flex align-items-center justify-content-center"
      style={{ margin: "0px 13px", padding: "25px" }}
    >
       🎉 Principal முழுவதும் செலுத்தப்பட்டது!  
     
    </div>
  ) : (
    <div className="w-100 d-flex flex-column">
      <label>Principal Pay</label>

      <input
        type="text"
        className="form-control w-100"
        value={principalPay === 0 ? "" : principalPay}
        placeholder={`Enter principal amount (Max ₹${
          customerData?.balance || customerData?.loan_amount || 0
        })`}
        onChange={(e) => {
          const val = e.target.value;

          if (!/^\d*\.?\d{0,2}$/.test(val)) return;

          const numericVal = val === "" ? 0 : Number(val);
          const maxAllowed = Number(
            customerData?.balance || customerData?.loan_amount || 0
          );

          if (numericVal > maxAllowed) {
            toast.error(`❗ Principal cannot exceed ₹${maxAllowed}`);
            return;
          }

          setPrincipalPay(numericVal);
        }}
      />
    </div>
  )}

</div>

</div>

{/* Payment Method Row */}
<div className="row mt-2">

  {/* Dropdown */}
  <div className="col-md-6 mb-2">
    <select 
      className="form-control"
      value={paymentMethod}
      onChange={(e) => setPaymentMethod(e.target.value)}
    >
      <option disabled value="">Select Payment Method</option>
      <option value="cash">Cash</option>
      <option value="upi">UPI</option>
      <option value="bank">Bank Transfer</option>
    </select>
  </div>

  {/* 👇 Conditional Input */}
  {paymentMethod === "upi" && (
    <div className="col-md-6 mb-2">
       <input
      type="text"
      className="form-control"
      placeholder="Enter UPI Number"
      value={upiNumber}
      maxLength={12}
      onChange={(e) => setUpiNumber(e.target.value)}
    />
    </div>
  )}

  {/* {paymentMethod === "bank" && (
    <div className="col-md-6 mb-2">
      <input 
        type="text" 
        className="form-control" 
        placeholder="Enter Bank Ref No" 
      />
    </div>
  )} */}

</div>

<div className="row mt-3">

  {/* ================= CLOSED DATE ================= */}
  <div className="col-md-6">
    <label>Closed Date</label>
    <input
      type="date"
      className="form-control"
      value={closedDate}
      onChange={(e) => setClosedDate(e.target.value)}
    />
  </div>

  {/* ================= STATUS (TEXT ONLY) ================= */}
  <div className="col-md-6 text-center">
    <label className="text-center">Status</label>
    <div className="form-control bg-light fw-bold">
      {customerData?.paid_status== "Active"?"Active":"Closed"}
    </div>
  </div>

</div>


 {customerData?.paid_status=="Closed"  ?<div
      className="alert alert-success w-100 mt-5 d-flex align-items-center justify-content-center"
      style={{ padding: "25px" }}
    >
 🎉 Your loan is fully paid and closed!
    </div>: <button className="btn btn-success w-100 mt-5 fw-bold" onClick={handlePay} style={{background:'#2F6B3F'}}>
    Pay Now
  </button>}
 
</div>

</div>
        


      
      </div>
    </div>
  );
}

export default CustomerPay;